// library imports
import { useState, useEffect, useContext } from "react";
import { Button, Table, Flex } from "antd";

// hook imports
import useFetch from "../../hooks/useFetch";

// context imports
import { IndexContext } from "../../context/IndexContext";

export default function FactorValueMarketBasedSelection({
  currentlyEditEmissionID,
  setIsModalOpen,
  getAllEmissionData,
  existingFactorValueMarketBasedData,
  existingFactorValueEmissionFactorIDList,
}) {
  const { notificationApi } = useContext(IndexContext);
  const [fetchWrapper] = useFetch();

  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
  };

  /** API to get get factor value selection */
  function getFactorValue() {
    fetchWrapper({
      endpoint_url: "emission_data_entry/getFactorValue",
      method: "GET",
      params: {
        activity_data_ID: currentlyEditEmissionID,
      },
      set_content_type_header: false,
      onSuccess: (response) => {
        if (response.data?.show_error) {
          notificationApi.error({
            message: response.message,
          });
        }
        setColumns(response.data.columns);
        setData(response.data.data);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: response.message,
        });
      },
    });
  }

  function saveFactorValueData(factorValueData) {
    fetchWrapper({
      endpoint_url: "emission_data_entry/saveFactorValue",
      method: "POST",
      params: {
        activity_data_ID: currentlyEditEmissionID,
        factor_value_data: factorValueData,
      },
      onSuccess: (response) => {
        notificationApi.success({
          message: response.message,
        });
        setIsModalOpen(false);
        getAllEmissionData();
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: response.message,
        });
      },
    });
  }

  useEffect(() => {
    if (currentlyEditEmissionID) {
      getFactorValue();
    }
  }, [currentlyEditEmissionID]);

  useEffect(() => {
    if (data.length > 0) {
      if (existingFactorValueEmissionFactorIDList) {
        // Function to compare 2 arrays (same elements, can be in different order)
        const arraysMatch = (a, b) => {
          const aSorted = [...a].sort();
          const bSorted = [...b].sort();
          return (
            aSorted.length === bSorted.length &&
            aSorted.every((val, i) => val === bSorted[i])
          );
        };

        // Find the matched row
        const matchedRow = data.find((item) =>
          arraysMatch(
            item.EmissionFactorIDList,
            existingFactorValueEmissionFactorIDList,
          ),
        );
        // Set selected row keys
        if (matchedRow) {
          setSelectedRows([matchedRow]);
          setSelectedRowKeys([matchedRow.key]);
        }
      }
    }
  }, [data]);

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        scroll={{ y: 500, x: 500 }}
        size="small"
        rowSelection={{
          ...rowSelection,
          checkStrictly: false,
          type: "radio",
        }}
      />
      <Flex justify="center">
        <Button
          className="mt-2"
          onClick={() => {
            saveFactorValueData(selectedRows);
          }}
          disabled={selectedRowKeys.length === 0}
        >
          Submit
        </Button>
      </Flex>
    </>
  );
}
